export const CHANNEL_DATA = 'KANBO_CHANNEL_DATA'
